var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-1" }, [
    _c("div", { staticClass: "flex-1" }, [
      _c("div", { staticClass: "py-6" }, [
        _c("h3", { staticClass: "text-lg font-medium mb-3" }, [
          _vm._v(" Step 9 of 9: Documentation Requirements "),
        ]),
        _c("div", { staticClass: "grid grid-cols-1 gap-3" }, [
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Progress Notes "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormTextarea", {
                    attrs: {
                      rows: 3,
                      customBorderClass: "borderTen",
                      name: "doc_progress_notes",
                      placeholder: "Type here",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("doc_progress_notes", val),
                    },
                    model: {
                      value: _vm.localFormData.doc_progress_notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "doc_progress_notes", $$v)
                      },
                      expression: "localFormData.doc_progress_notes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Incident Reports "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormTextarea", {
                    attrs: {
                      rows: 3,
                      customBorderClass: "borderTen",
                      name: "doc_incident_reports",
                      placeholder: "Type here",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("doc_incident_reports", val),
                    },
                    model: {
                      value: _vm.localFormData.doc_incident_reports,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "doc_incident_reports", $$v)
                      },
                      expression: "localFormData.doc_incident_reports",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Changes Noted "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "review_changes_notes",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("review_changes_notes", val),
                    },
                    model: {
                      value: _vm.localFormData.review_changes_notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "review_changes_notes", $$v)
                      },
                      expression: "localFormData.review_changes_notes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" New Goals "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "review_new_goals",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("review_new_goals", val),
                    },
                    model: {
                      value: _vm.localFormData.review_new_goals,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "review_new_goals", $$v)
                      },
                      expression: "localFormData.review_new_goals",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" General Notes "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormTextarea", {
                    attrs: {
                      customBorderClass: "borderTen",
                      name: "review_general_notes",
                      placeholder: "Type here",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("review_general_notes", val),
                    },
                    model: {
                      value: _vm.localFormData.review_general_notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "review_general_notes", $$v)
                      },
                      expression: "localFormData.review_general_notes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" Supporting Documents "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("CarePlanDocument", {
                    attrs: {
                      isProject: true,
                      projectCompleted: _vm.formData.completed,
                      projectId: _vm.localFormData.id,
                      userRole: _vm.currentUser.role,
                      currentUser: _vm.currentUser,
                      companyId: _vm.companyId,
                      clientId: _vm.clientId,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [
        _vm._v("Care Plan Review"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }